<script lang="ts">
  import Status from "./Status.svelte";
  import Sizing from "./Sizing.svelte";
  import Initials from "./Initials.svelte";
  import Shape from "./Shape.svelte";
  import Groups from "./Groups.svelte";
  import BookmarkAvatars from "./BookmarkAvatars.svelte";
  import { Container,Row } from "sveltestrap";
  import { onMount } from "svelte";
  import PreLodaer from "../../../Layout/PreLoader/PreLodaer.svelte";
  let ispreloader:boolean = false;
  onMount(() => {
		setTimeout(() => {
			ispreloader = true;
		}, 1000);
	});
</script>
{#if !ispreloader }
  <PreLodaer />
{/if}
<BookmarkAvatars />
<Container fluid>
  <div class="user-profile">
    <Row>
      <Sizing />
      <Status />
      <Initials />
      <Shape />
      <Groups />
    </Row>
  </div>
</Container>
